module.exports = __webpack_public_path__ + "3850dee650df105fd3c4bf7e19a576a1.ttf";